<template>
    <div id="order" ref="tel">
        <div class="initialize" ref="init">
            <div class="plate">
                <img src="/img/plate.png" alt="plate">
            </div>
            <div class="pointer">
                <img src="/img/pointer.png" alt="pointer">
            </div>
        </div>
        <div class="header" ref="header"></div>
        <div class="discount">
            <p class="dec">
                已有
                <span>{{discountdata.userNum}}</span>
                名用户进行解签，
                <span>{{discountdata.userPer}}%</span>
                的用户认为解签结果对自己的人生产生了巨大帮助。
            </p>
            <p class="old-price">
                原价 ¥{{discountdata.oldPrice}}
            </p>
            <p class="new-price">
                <img src="/img/oclock.png" alt="" class="icon">
                <span> 限时优惠</span>
                <span>¥{{discountdata.newPrice}}</span>
            </p>
        </div>
        <div class="payment" ref="pay">
            <p class="title">支付方式</p>
            <ul class="paycontent" ref="paycontent">
                <li v-for="(item,index) in payData" :key="index">
                    <img :src="item.icon" alt="" class="icon">
                    <span>{{item.title}}</span>
                    <button class="btn" @click="handlepay(item.url)">立即支付</button>
                </li>
            </ul>
        </div>
        <div class="userback">
            <div class="title">
                <img src="https://tianjipic.oss-cn-beijing.aliyuncs.com/projectAll/gylq/yhfk.png" alt="" @click="">
            </div>
            <div class="content">
                <p class="dec">
                    本解签一共帮助
                    <span>
                        {{contentdata.userNum}}
                    </span>
                    名用户，
                    <span>
                        {{contentdata.userPer}}
                    </span>
                    的用户解签后，对结果非常满意。
                </p>
                <div class="score">
                    <p>{{contentdata.score}}</p>
                    <div class="stars">
                        <p>评分:</p>
                        <ul>
                            <li
                                    v-for="item in startdata"
                            >
                                <img :src="item.src" alt="">
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="evaluate">
                    <ul>
                        <li v-for="item in evaluatedata">
                            <span>{{item}}</span>
                        </li>
                    </ul>
                </div>
                <div class="comment">
                    <ul ref="commentbox">
                        <li v-for="item in commentdata" ref="comment">
                            <h4>{{item.user}}</h4>
                            <p>{{item.content}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="bottom-pay hide" ref="bottmpay" @click="handlePayback">
            <p>立即支付</p>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'order',
        data() {
            return {
                showOid: '',
                score: 9.96,
                discountdata: {
                    userNum: 2607397,
                    userPer: 95,
                    oldPrice: '58',
                    newPrice: '9.9',
                },
                contentdata: {
                    userNum: 2607397,
                    userPer: 95,
                    score: '9.95'
                },
                startdata: [
                    {
                        src: '/img/fullstar.png'
                    },
                    {
                        src: '/img/fullstar.png'
                    },
                    {
                        src: '/img/fullstar.png'
                    },
                    {
                        src: '/img/fullstar.png'
                    },
                    {
                        src: '/img/banstar.png'
                    },
                ],
                evaluatedata: ['分析到位', '豁然开朗', '命运解读'],
                commentdata: [
                    {
                        user: '王*',
                        content: `抽到了上上签，哈哈，解签里说的自己命运一帆风顺，但愿如此，心诚则灵！`
                    },
                    {
                        user: '李*',
                        content: `测算的结果以及建议非常值得参考，价格也很接地气，改天再来抽一签。 `
                    },
                    {
                        user: '张**',
                        content: `感情方面一直不顺，所以来抽一签试试，果然分析的很到位，比在外面算卦还要准。`
                    },
                    {
                        user: '陈*',
                        content: `产品整体操作流畅，解签专业，求得上上签，观音保佑。`
                    },
                    {
                        user: '孙**',
                        content: `心诚则灵，信则有，不信则无，解签的内容还是很贴合自身的，望观音保佑🙏`
                    },
                    {
                        user: '郑*',
                        content: `朋友推荐过来的，说很准，由于最近事业不顺就来试试，抽的下下签，签中说我工作的方位于命中相反，应该在东南方向发展，我就是从那个方向回来以后才不顺的，真的很准 `
                    },
                    {
                        user: '朱**',
                        content: `连续抽了两次，内容分析的比较到位，看来还是自己的运气好！！ `
                    },
                    {
                        user: '施**',
                        content: `真的很划算，关键是解签的内容很满意，值得推荐给身边人的产品`
                    },
                    {
                        user: '贝*',
                        content: ` 婚后一直想要孩子，但日复一日，都没如愿，就特地来求签，解签说在明年的三月份会有好转希望如此`
                    },
                ],
                payData: []
            }
        },
        methods: {
            //rem设定
            handleSetFontSize() {
                let oHtml = document.getElementById('gyjq');
                fontSize();
                window.onresize = fontSize;

                function fontSize() {
                    oHtml.style.fontSize = window.innerWidth >= 750 ? 75 + 'px' : oHtml.style.fontSize
                }
            },
            //页面初始化
            handleinte() {
                try {
                    setTimeout(() => {
                        let init = this.$refs.init;
                        new Promise(res => {
                            init.children.forEach((ele, index) => {
                                ele.classList.add('opa')
                            })
                            this.handleshoworder(res);
                        }).then(val => {
                            return new Promise(res => {
                                setTimeout(() => {
                                    init.children.forEach((ele, index) => {
                                        ele.classList.remove('opa');
                                        init.style.opacity = '0';
                                        setTimeout(() => {
                                            init.style.display = 'none';
                                        }, 2000)
                                    })
                                }, 600)
                            })
                        })
                    })
                } catch (e) {
                    console.log(e);
                }
            },
            //用户评论滚动
            handleScrollTop() {
                let commentbox = this.$refs.commentbox,
                    comment = this.$refs.commentbox.children,
                    swich = true;

                function scroll() {
                    //swich
                    if (swich == false) return;
                    swich = false;
                    //添加动画，移动盒子
                    commentbox.offsetLeft;
                    commentbox.style.transition = `top 2s`;
                    if (commentbox.append) {
                        commentbox.style.top = `-1.88rem`;
                    } else {
                        commentbox.style.top = `-1.66rem`;
                    }

                    setTimeout(() => {
                        //创建li赋值为当前队列中的第一条评论
                        let Li = document.createElement('li');
                        Li = comment[0];
                        //删除第一个评论
                        commentbox.removeChild(comment[0]);
                        commentbox.style.transition = `top 0s`
                        commentbox.style.top = `0`;
                        if (commentbox.append) {
                            commentbox.append(Li);
                        } else {
                            commentbox.appendChild(Li);
                        }
                        swich = true;
                    }, 2000)
                }

                setInterval(scroll, 4000);
            },
            //支付按钮
            handlepay(url) {
                window.open(url)
            },
            //滚轮事件
            handleMouseScroll() {
                const _this = this;
                let tel = this.$refs.tel,
                    pay = this.$refs.pay,
                    bottmpay = this.$refs.bottmpay,
                    topnum = 0;

                //显示/隐藏底部的支付按钮
                function showHide() {
                    topnum = pay.getBoundingClientRect().top - document.documentElement.clientTop;
                    if (topnum <= 250) {
                        bottmpay.classList.remove('hide');
                    } else {
                        bottmpay.classList.add('hide');
                    }
                }

                //鼠标事件滚轮兼容
                function mouseScroll(ele, aFn) {
                    if (document.createElement('div').onmousewheel === null) {

                        ele.addEventListener('mousewheel', function () {
                            aFn();
                        }, false)
                    } else {
                        ele.addEventListener('DOMMouseScroll', function () {
                            aFn();
                        }, false)
                    }
                }

                //执行事件
                mouseScroll(tel, showHide)
            },
            //下单数据挂载
            handleshoworder(result) {
                let oid=this.$route.query.oid;
                const _this=this;
                this.Axios.get(`?ct=app&ac=showorder&oid=${oid}`).then(res =>{
                    if(res.data.status===1){
                        //数据挂载
                        let resData=res.data.data;

                        //描述部分
                        _this.discountdata.newPrice=resData.money;//新价格

                        //按钮部分
                        _this.payData=res.data.info
                        return result();
                    }
                })
            },
            //滚动到指定窗口
            handlePayback() {
                this.$refs.header.scrollIntoView({
                    behavior: 'smooth',
                    alignToTop: false
                });
                this.$refs.bottmpay.classList.add('hide');
            },
            //是否付费状态获取
            handleIspay(){
                const _this=this;
                let iSpaytimer=setInterval(getIspay,1000);
                function getIspay(){
                    _this.Axios.post(`?ct=app&ac=ispay&oid=${_this.$route.query.oid}`).then(res=>{
                        if(res.data.data.status == 1){
                            clearInterval(iSpaytimer);
                            _this.$router.push({
                                path:'/result',
                                query:{
                                    oid:_this.$route.query.oid
                                }
                            })
                        }
                    })
                }
            }
        },
        created() {
            this.handleIspay();
            this.$nextTick(() => {
                this.handleScrollTop();
                this.handleMouseScroll();
                this.handleinte();
            })
        },
        activated() {
            this.$nextTick(() => {
                this.handleinte();
            })
        },
    };
</script>
<style lang="scss">
    #order {
        max-width: 750px;
        margin: 0 auto;
        background-color: #f3e0cb;

        .initialize {
            position: fixed;
            top: 0;
            z-index: 100;
            height: 100%;
            width: 10rem;
            background-color: rgba(0, 0, 0, .6);
            transition: .6s;

            .plate {
                img {
                    animation: rotateplate 2s infinite linear
                }
            }

            .pointer {
                img {
                    animation: rotatepointer 2s infinite linear;
                }
            }

            .plate, .pointer {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                transition: .6s;
                opacity: .4;
            }

            .plate.opa, .pointer.opa {
                opacity: 1;
            }
        }

        .header {
            width: 100%;
            height: 4.4rem;
            background: url("https://tianjipic.oss-cn-beijing.aliyuncs.com/projectAll/gylq/guanyin_new2.png") no-repeat center/cover;
        }

        .discount {
            border: 4px solid #ee8118;
            margin: 0.3rem 0.3rem;
            padding-bottom: 1rem;
            background: #facf3f;
            border-radius: 0.2rem;
            color: #fff;

            .dec {
                padding: .25rem;
                text-align: left;
                font-size: 0.4rem;
                border-bottom: 1px dashed #fff;

                span {
                    color: red;
                }
            }

            .old-price {
                color: #000;
                text-decoration: line-through;
                font-size: 0.6rem;
                padding-top: .5rem;
                line-height: 0.5rem;
            }

            .new-price {
                box-sizing: border-box;
                font-size: 0.6rem;
                height: .6rem;
                padding: 0.05rem 0.3rem 0.1rem;
                margin-top: .4rem;
                color: #f44902;

                .icon {
                    display: inline-block;
                    height: 44px;
                    transform: translateY(16%);
                }

                span {
                    line-height: .6rem;
                }
            }
        }

        .userback {
            .title {
                width: 94%;
                margin: .3rem auto .5rem;

                img {
                    width: 100%;
                    display: block;
                }
            }

            .content {
                box-sizing: border-box;
                margin: 0.1rem 0.3rem;
                background: #fff;
                border: 0.0625rem solid #ffbe53;
                border-radius: 0.2rem;

                .dec {
                    margin: .3rem;
                    text-align: center;
                    font-size: 0.4rem;

                    span {
                        color: red;
                    }
                }

                .score {
                    p {
                        font-size: 1rem;
                        font-weight: bold;
                        color: red;
                    }

                    .stars {
                        display: flex;
                        justify-content: center;

                        p {
                            font-size: .5rem;
                            color: #000;
                        }

                        ul {
                            li {
                                margin-top: 4px;
                                margin-left: 8px;
                                display: inline-block;

                                img {
                                    width: .6rem;
                                }
                            }
                        }
                    }
                }

                .evaluate {
                    margin-top: .2rem;
                    padding-bottom: .4rem;
                    border-bottom: 0.2rem solid rgb(221, 221, 221);

                    ul {
                        display: flex;
                        justify-content: space-around;

                        li {
                            padding: 20px 40px;
                            background-color: #ececec;
                            border-radius: 0.1rem;
                            vertical-align: top;

                            span {
                                display: block;
                                height: 100%;
                                line-height: 100%;
                                font-size: .36rem;
                            }
                        }
                    }
                }

                .comment {
                    overflow: hidden;
                    height: 7.4rem;

                    ul {
                        position: relative;
                        top: 0;

                        li {
                            position: relative;
                            top: 0;
                            font-size: .52rem;
                            padding: 0 0.4rem;
                            text-align: left;
                            color: #111;

                            p {
                                padding-bottom: .2rem;
                                font-size: .36rem;
                                color: #777;
                                border-bottom: 1px dashed #666;
                            }
                        }
                    }
                }
            }
        }

        .payment {
            width: 9.4rem;
            margin: 0 auto;
            border-radius: 0.2rem;

            .title {
                color: rgb(255, 255, 255);
                background: rgb(255, 106, 59);
                padding: .1rem 0.4rem .15rem;
                text-align: center;
                font-size: 0.4rem;
            }

            .paycontent {
                background-color: #fff;
                padding: .2rem 0;
                display: flex;
                justify-content: space-around;
                flex-wrap: wrap;

                li {
                    display: flex;
                    width: 85%;
                    justify-content: space-between;

                    span {
                        font-size: .44rem;
                        height: .9rem;
                        line-height: .9rem;
                        margin: 0;
                    }

                    img {
                        width: .7rem;
                        margin: auto 0;
                        vertical-align: bottom;
                    }

                    .btn {
                        margin: auto 0;
                        padding: 0.1rem 0.25rem;
                        font-size: 0.35rem;
                        color: #fff;
                        border: none;
                        line-height: 0.5rem;
                        background-color: #ff6a3b;
                        border-radius: 0.1rem;
                        cursor: pointer;
                    }
                }
            }
        }

        .bottom-pay {
            position: fixed;
            bottom: 0;
            z-index: 999;
            width: 10rem;
            background-color: rgba(0, 0, 0, .3);
            padding: .2rem 0;

            p {
                width: 9rem;
                margin: 0 auto;
                height: 1rem;
                background: rgb(255, 106, 59);
                font-size: 0.5rem;
                text-align: center;
                line-height: 1rem;
                color: rgb(255, 255, 255);
                border-radius: 0.15rem;
            }
        }

        .bottom-pay.hide {
            display: none;
        }
    }

    @keyframes rotateplate {
        0% {
            transform: rotate(0)
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes rotatepointer {
        0% {
            transform: rotate(360deg)
        }
        100% {
            transform: rotate(0);
        }
    }
</style>